import { useContext, useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { dateConvert } from "../../../utils/Helper";
import { callautopopulate } from "../../../services/callautopop";


export const useAccess = ({ setShowRequestPopup, callApi, dropdownOption, editData, projectOpts }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [projectAccessRequestData, setProjectAccessRequestData] = useState({ is_billable: true });
    const [mismatchedUsers, setMismatchedUsers] = useState([])
    const [previousData, setPreviousData] = useState({});
    const [options, setOptions] = useState({});
    const [loader, setLoader] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [confirmation, setConfirmation] = useState({});

    useEffect(() => {
        if (!_.isEmpty(editData) && projectOpts?.length > 0) {
            const project = _.findWhere(projectOpts, { project_id: editData?.project_id })
            const assigned = _.where(dropdownOption?.assignedTo, { user_code: editData?.requested_user_code })
            const show = _.findWhere(dropdownOption?.action, { request_type_id: editData?.request_type_id })?.request_type_key === "helpdesk_grant_tab"
            const data = {
                project_id: project,
                projectRole: _.findWhere(dropdownOption?.projectRole, { project_role_id: editData?.project_role_id }),
                // requestTo: _.findWhere(dropdownOption?.requestTo, { user_code: editData?.approver_user_code }),
                request_type_id: _.findWhere(dropdownOption?.action, { request_type_id: editData?.request_type_id })?.request_type_key,
                show: show ? true : false,
                assignedTo: assigned,
                endDate: editData?.expiry_datetime !== null ? new Date(editData?.expiry_datetime) : '',
                is_edit: true,
                project_request_id: editData?.project_request_id,
                is_billable: editData?.is_billable
            }
            getProjectUserList(project, show)
            !show && getUserRoleList({ ...assigned?.[0], project_id: project?.project_id })
            setProjectAccessRequestData(data)
            setPreviousData(data)
        }
    }, [editData, projectOpts]);

    const getProjectUserList = async (id, show) => {
        try {
            const payload = {
                "project_id": id?.project_id,
                "product_code": id?.product_code,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTUSERLIST"), payload);
            if (res?.status === 200) {
                if (res?.body?.data?.project_User_List) {
                    setOptions((prev) => ({
                        ...prev, userList: _.sortBy(res?.body?.data?.project_User_List, "user_display_name"),
                        leadList: _.uniq(res?.body?.data?.project_lead_list, "project_lead_user_code")
                    }))
                    const lead = _.uniq(_.pluck(res?.body?.data?.project_User_List, "project_lead_user_code"))
                    setProjectAccessRequestData((prev) => ({
                        ...prev,
                        requestTo: _.findWhere(res?.body?.data?.project_lead_list, { project_lead_user_code: lead[0] }),
                        assignedTo: show ? _.where(dropdownOption?.assignedTo, { user_code: editData?.requested_user_code }) : _.find(res?.body?.data?.project_User_List, { user_code: editData?.requested_user_code })
                    }))
                    if (!_.isEmpty(editData)) {
                        setProjectAccessRequestData((prev) => ({
                            ...prev,
                            requestTo: _.find(res?.body?.data?.project_lead_list, { project_lead_user_code: editData?.approver_user_code }),
                            assignedTo: show ? _.where(dropdownOption?.assignedTo, { user_code: editData?.requested_user_code }) : _.find(res?.body?.data?.project_User_List, { user_code: editData?.requested_user_code })
                        }))
                        setPreviousData((prev) => ({
                            ...prev,
                            requestTo: _.find(res?.body?.data?.project_lead_list, { project_lead_user_code: editData?.approver_user_code }),
                            assignedTo: show ? _.where(dropdownOption?.assignedTo, { user_code: editData?.requested_user_code }) : _.find(res?.body?.data?.project_User_List, { user_code: editData?.requested_user_code })
                        }))
                    }

                }
            } else {
                setOptions([])
            }

        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }


    const getUserRoleList = async (id) => {
        try {
            const payload = {
                "project_id": id?.project_id,
                "requested_user_code": id?.user_code,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTREVOKEREQUESTUSERROLES"), payload);
            if (res?.status === 200) {
                if (res?.body?.data?.project_user_roles_list) {
                    const uniq = _.uniq(res?.body?.data?.project_user_roles_list, "project_role_id")
                    setOptions((prev) => ({ ...prev, projectRole: uniq, }))
                    if (!_.isEmpty(editData)) {
                        setProjectAccessRequestData((prev) => ({ ...prev, projectRole: _.where(uniq, { project_role_id: editData?.project_role_id }) }))
                    } else {
                        setProjectAccessRequestData((prev) => ({ ...prev, projectRole: uniq }))
                    }
                }
            } else {
                setOptions([])
            }

        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        if (name === "request_type_id") {
            setProjectAccessRequestData({ [name]: value, show: value === "helpdesk_grant_tab" ? true : false, is_billable: true })

        } else if (name === "project_id") {
            getProjectUserList(value, projectAccessRequestData?.show)
            setProjectAccessRequestData((prev) => ({ ...prev, [name]: value, projectRole: null }))
        } else if (name === "assignedTo" && !projectAccessRequestData?.show) {
            projectAccessRequestData?.request_type_id !== "helpdesk_grant_tab" && getUserRoleList(value)
            setProjectAccessRequestData((prev) => ({ ...prev, [name]: value, projectRole: null }))
        } else if (name === "assignedTo" && projectAccessRequestData?.show) {
            setProjectAccessRequestData((prev) => ({ ...prev, [name]: value, }))
        } else if (name === "projectRole") {
            const result = new Date();
            const daysToAdd = value?.exp_days ? value?.exp_days : 15;
            result.setDate(result.getDate() + daysToAdd);
            setProjectAccessRequestData((prev) => ({ ...prev, [name]: value, endDate: result }))
        }
        else if (name === "is_billable") {
            setProjectAccessRequestData((prev) => ({ ...prev, [name]: e.target.checked }))
        }
        else {
            setProjectAccessRequestData((prev) => ({ ...prev, [name]: value }))
        }
    }

    const handleRadioChange = (value) => {
        const mismatched = projectAccessRequestData?.assignedTo?.filter(u => u.is_billable !== value);
        if (mismatched.length > 0) {
            setMismatchedUsers(mismatched);
            setShowPopup(true);
        }
        handleChange({ target: { name: "is_billable", value } });
    };

    const handleSelection = () => {
        const check = getBillableStatus(projectAccessRequestData.assignedTo)
        if (check !== null) {
            setProjectAccessRequestData((prev) => ({
                ...prev, assignedTo: projectAccessRequestData.assignedTo, is_billable: check
            }));
        } else {
            const selected = projectAccessRequestData.assignedTo.filter(users => !mismatchedUsers.some(user => user.user_code === users.user_code))
            setProjectAccessRequestData((prev) => ({
                ...prev, assignedTo: selected, is_billable: getBillableStatus(selected)
            }));
            setConfirmation({})
            showInfo("Info", "These users have been deselected. You need to add them separately based on their billable status.");
        }

    };

    const getBillableStatus = (selectedUsers) => {
        if (selectedUsers.every(u => u.is_billable === true)) return true;
        if (selectedUsers.every(u => u.is_billable === false)) return false;
        return null;
    };


    const ProjectAccessRequestUpsert = async () => {
        const request_tye = projectAccessRequestData.request_type_id === "helpdesk_grant_tab"
        if (_.isEqual(projectAccessRequestData, previousData)) {
            showInfo("info", "No changes made");
            return;
        }
        const action = _.findWhere(dropdownOption.action, { request_type_key: projectAccessRequestData.request_type_id });
        if (!action) {
            showInfo("info", 'Please Select Action Type');
            return;
        }
        if (_.isEmpty(projectAccessRequestData?.project_id)) {
            showInfo("info", 'Please Select Project Name');
            return;
        }
        if (_.isEmpty(projectAccessRequestData?.projectRole)) {
            showInfo("info", 'Please Select Project Role');
            return;
        }
        if (!projectAccessRequestData?.endDate && request_tye) {
            showInfo("info", 'Please Select Expiry date');
            return;
        }
        if (_.isEmpty(projectAccessRequestData?.assignedTo)) {
            showInfo("info", 'Please Select Assignee ');
            return;
        }
        if (_.isEmpty(projectAccessRequestData?.requestTo)) {
            showInfo("info", 'Please Select Request To');
            return;
        }
        setLoader(true)
        try {
            const payload = {
                "project_request_id": projectAccessRequestData?.project_request_id || 0,
                "project_id": projectAccessRequestData?.project_id?.project_id,
                "product_code": projectAccessRequestData?.project_id?.product_code,
                "project_role_ids": !request_tye ? _.pluck(projectAccessRequestData?.projectRole, 'project_role_id')?.toString() : projectAccessRequestData?.projectRole?.project_role_id?.toString(),
                "request_type_id": action?.request_type_id,
                "user_codes": !request_tye ? projectAccessRequestData?.assignedTo?.user_code?.toString() : _.pluck(projectAccessRequestData?.assignedTo, 'user_code')?.toString(),
                "approver_user_code": projectAccessRequestData?.requestTo?.project_lead_user_code,
                "expiry_datetime": projectAccessRequestData?.endDate !== null ? dateConvert(projectAccessRequestData?.endDate, 'iso-string') : null,
                "is_billable": !request_tye && projectAccessRequestData?.is_billable === undefined ? false : projectAccessRequestData?.is_billable || false
            }
            const res = await services.getInvokeRemote("POST", Urls("SENDPROJECTREQUESTUPESERT"), payload);
            if (res?.StatusCode === 202 || res?.status === 202) {
                showError("Error", res.body.errorMessage);
                setLoader(false);
            } else if (res.body.data) {
                showSuccess('Sucess', res.body.message)
                setShowRequestPopup(false)
                callApi()
                setLoader(false);
            }
        } catch (error) {
            setLoader(false)
            showError("Error", error?.response?.data?.errorMessage);

        }
    }


    const upsertStatusOfBillable = async () => {
        try {
            if (!confirmation?.remark?.trim()) {
                showInfo("info", "Please enter remark.");
                return;
            }
            const payload = {
                "requested_user_codes": _.pluck(mismatchedUsers, "user_code").toString(),
                "is_billable": projectAccessRequestData?.is_billable,
                "remark": confirmation?.remark
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTBILLABLEUSERSDATA"), payload)
            if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 || res.body.StatusCode === 500) {
                showError("Error", res.body.errorMessage);
            }
            else if (res.status === 200) {
                showSuccess('Sucess', res.body.message)
                setShowPopup(false)
                setConfirmation({})
                sessionStorage.removeItem("all_users");
                callautopopulate("all_users").then((res) => {
                    dropdownOption.assignedTo = _.sortBy(_.uniq(res?.all_users, (item) => item.user_code), "user_display_name")
                    const matchedUsers = dropdownOption.assignedTo.filter(user1 =>
                        projectAccessRequestData?.assignedTo.some(user2 => user1.user_code === user2.user_code)
                    );
                    setProjectAccessRequestData((prev) => ({ ...prev, assignedTo: matchedUsers }))
                }).catch((error) => {
                    console.error("error", error)
                })
            } else {
                showError("Error", res.body.message)
            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
        }
    }


    return useMemo(() => ({
        ProjectAccessRequestUpsert, handleChange, projectAccessRequestData, setProjectAccessRequestData, options, loader, showPopup, setShowPopup, handleRadioChange, mismatchedUsers, confirmation, setConfirmation, handleSelection, upsertStatusOfBillable
    }), [ProjectAccessRequestUpsert, handleChange, projectAccessRequestData, setProjectAccessRequestData, options, loader, showPopup, setShowPopup, handleRadioChange, mismatchedUsers, confirmation, setConfirmation, handleSelection, upsertStatusOfBillable]);
}